import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("product", ["product", "coupon"]),
    ...mapState("membersModules", ["module"]),
    ...mapState("user", ["myCoproducers"]),
    productRoutes() {
      return {
        product: {
          title: "Meus produtos"
        },
        "coproducer-product-links": {
          title: (() => {
            const productName = this.myCoproducers.find(
              coproducer => coproducer.product?.id == this.$route.params.id
            )?.product?.name;
            return productName
              ? productName + " - Links de divulgação"
              : "Links de divulgação";
          })()
        },

        "product-new": {
          title: "Novo produto"
        },
        "product-new-event": {
          title: "Ingressos para eventos presenciais"
        },
        "product-new-online-course": {
          title: "Curso online"
        },
        "product-new-signature": {
          title: "Assinatura"
        },
        product: {
          title: "Meus produtos"
        },
        "product-details": {
          title: this.product?.name || "..."
        },
        "product-basic-info": {
          title: "Informações básicas"
        },
        "product-coproducers": {
          title: "Coproduções"
        },
        "product-new-coproducer": {
          title: "Cadastrar coprodutor"
        },
        "product-funnel": {
          title: "Funis de Vendas"
        },
        "product-funnel-tree": {
          title: "Funil de Vendas"
        },
        "product-links": {
          title: "Links de divulgação"
        },
        "product-oneclickbuy": {
          title: "Link one click buy"
        },
        "product-prices": {
          title: "Precificação e ofertas"
        },
        "product-plans": {
          title: "Precificação e planos"
        },
        "product-new-plan": {
          title: "Novo plano"
        },
        "product-edit-plan": {
          title: "Editar plano"
        },
        "product-analytics": {
          title: "Api de conversões"
        },
        "product-facebook-pixel": {
          title: "Píxel do Facebook"
        },
        "product-google-analytics": {
          title: "Google Analytics"
        },

        "product-prices": {
          title: "Precificação e ofertas"
        },
        "product-prices-new": {
          title: "Nova Oferta"
        },
        "product-prices-main": {
          title: "Oferta Principal"
        },
        "product-prices-edit": {
          title: "Editar Oferta"
        },

        // EVENTOS
        "event-lots": {
          title: "Ingressos"
        },
        "event-new-lot": {
          title: "Novo ingresso"
        },
        "event-edit-lot": {
          title: this.lot?.name || "Editar ingresso",
          params: {
            lot_code: this.$route.params.lot_code
          }
        },
        "event-participants": {
          title: "Participantes"
        },

        // CUPOM
        "product-coupons": {
          title: "Cupons"
        },
        "product-coupon": {
          title: this.$route.params.coupon ? "Editar cupom" : "Novo cupom"
        },
        "product-new-coupon": {
          title: "Novo cupom"
        },
        "product-edit-coupon": {
          title: "Editar cupom",
          params: {
            coupon_id: this.$route.params.coupon_id
          }
        },

        // CHECKOUT
        "config-checkout": {
          title: "Configurar checkout"
        },
        "personalize-checkout": {
          title: "Personalizar checkout"
        },

        // UPSELL
        "product-upsell": {
          title: "Funil de vendas"
        },
        "product-upsell-new": {
          title: "Novo funil"
        },
        "product-upsell-tree": {
          title: "Editar etapas"
        },
        "product-upsell-edit": {
          title: "Editar funil"
        },

        // PIXEL
        "product-edit-pixel": {
          title: "Pixel de rastreamento"
        },

        // ÁREA DE MEMBROS
        "product-member-area-setup": {
          title: "Configurar área de membros"
        },
        "product-member-area-modules": {
          title: "Conteúdo"
        },
        "product-member-area-modules-detail": {
          title: this.module ? this.module.name : "Módulo"
        },
        "product-members-module-add": {
          title: "Novo módulo"
        },
        "product-members-module-edit": {
          title: "Editar módulo"
        },
        "product-members-lesson-add": {
          title: "Nova aula"
        },
        "product-members-lesson-edit": {
          title: "Editar aula"
        },
        "product-members-submodule-add": {
          title: "Adicionar submódulo"
        },
        "product-members-submodule-edit": {
          title: "Editar submódulo"
        },
        "product-module-quiz-add": {
          title: "Adicionar quiz"
        },
        "product-module-quiz-add-question": {
          title: "Adicionar questão"
        },
        "product-member-area-categories": {
          title: "Categorias"
        },
        "product-member-area-students": {
          title: "Alunos"
        },
        "product-member-area-groups": {
          title: "Turmas"
        },
        "product-member-area-groups-add": {
          title: "Adicionar turma"
        },
        "product-member-area-groups-edit": {
          title: "Editar turma"
        },
        "product-member-area-comments": {
          title: "Comentários"
        },
        "product-members-module-quizz-add": {
          title: "Adicionar prova"
        },
        "product-members-module-quizz-edit": {
          title: "Editar prova"
        },
        "product-members-module-quizz-final-add": {
          title: "Adicionar prova final"
        },
        "product-members-module-quizz-final-edit": {
          title: "Editar prova final"
        }
      };
    }
  }
};
